import { useState, useEffect } from 'react';
import toast from 'react-hot-toast';

export const usePWAInstall = () => {
    const [deferredPrompt, setDeferredPrompt] = useState(null);

    useEffect(() => {
        const handler = (e) => {
            // Prevent the mini-infobar from appearing on mobile
            e.preventDefault();
            // Stash the event so it can be triggered later.
            setDeferredPrompt(e);
            
            // Show toast asking user to install the app
            toast((t) => (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    <div style={{ fontWeight: '600' }}>Install App for better experience</div>
                    <div style={{ fontSize: '0.9em', color: '#64748b' }}>Get quick access from your home screen.</div>
                    <div style={{ display: 'flex', gap: '10px', marginTop: '5px' }}>
                        <button
                            onClick={() => {
                                toast.dismiss(t.id);
                                // Show the install prompt
                                e.prompt();
                                // Wait for the user to respond to the prompt
                                e.userChoice.then((choiceResult) => {
                                    if (choiceResult.outcome === 'accepted') {
                                        console.log('User accepted the install prompt');
                                    } else {
                                        console.log('User dismissed the install prompt');
                                    }
                                    setDeferredPrompt(null);
                                });
                            }}
                            style={{
                                background: 'var(--primary-orange, #ea580c)',
                                color: 'white',
                                border: 'none',
                                padding: '6px 12px',
                                borderRadius: '6px',
                                fontWeight: '600',
                                cursor: 'pointer',
                                flex: 1
                            }}
                        >
                            Install Now
                        </button>
                        <button
                            onClick={() => toast.dismiss(t.id)}
                            style={{
                                background: '#e2e8f0',
                                color: '#475569',
                                border: 'none',
                                padding: '6px 12px',
                                borderRadius: '6px',
                                fontWeight: '600',
                                cursor: 'pointer',
                                flex: 1
                            }}
                        >
                            Not Now
                        </button>
                    </div>
                </div>
            ), {
                duration: 10000, // Show for 10 seconds
                position: 'bottom-center',
                id: 'pwa-install-toast'
            });
        };

        window.addEventListener('beforeinstallprompt', handler);

        return () => window.removeEventListener('beforeinstallprompt', handler);
    }, []);

    return deferredPrompt;
};

export default usePWAInstall;
